import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  value: '12€',
  title: 'Pianificazione Annuale Completa',
  desc: "Piano didattico già scritto per tutto l'anno, dal biennio al triennio. Include template bimestrale, piano di lezione individuale e strategie per BES e DSA. Apri il file e il tuo anno è già organizzato."
}, {
  num: '02',
  value: '15€',
  title: 'Banco di Esercizi Pronti',
  desc: 'Più di 55 esercizi su 4 livelli di difficoltà più 5 attività unplugged complete. Pronte per essere usate domani mattina senza preparazione aggiuntiva.'
}, {
  num: '03',
  value: '14€',
  title: 'Sistema di Valutazione Professionale',
  desc: 'Rubriche analitiche per verifiche scritte, pratiche al computer, progetti e presentazioni orali. Include griglie di conversione voto e template portfolio studente.'
}, {
  num: '04',
  value: '15€',
  title: 'Progetti Guidati per Laboratorio',
  desc: '5 progetti completi con soluzione per il docente, codice skeleton per gli studenti, test case e rubrica di valutazione specifica per ognuno.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-36" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-38">
          <div className="bg-brand-orange/20 p-3 rounded-full mb-3" data-id="element-39">
            <GiftIcon className="w-8 h-8 text-brand-orange" data-id="element-40" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-2" data-id="element-41">
            4 Bonus Esclusivi nel tuo Kit, senza costi extra.
          </h2>
          <p className="text-sm text-brand-gold font-bold" data-id="element-42">
            Del valore di 56 € in regalo con l'acquisto.
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-43">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-5 rounded-2xl" data-id="element-44">
              <div className="flex items-center gap-2 mb-2" data-id="element-45">
                <span className="text-brand-orange font-black text-xs tracking-widest" data-id="element-46">
                  {bonus.num}
                </span>
                <span className="text-gray-600" data-id="element-47">|</span>
                <span className="text-xs font-black text-brand-gold uppercase" data-id="element-48">
                  Valore {bonus.value} — GRATIS
                </span>
              </div>
              <div className="flex items-start gap-2 mb-2" data-id="element-49">
                <span className="text-2xl" data-id="element-50">📘</span>
                <h3 className="text-base sm:text-lg font-bold text-brand-cream leading-tight" data-id="element-51">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-sm text-gray-400 font-medium leading-snug" data-id="element-52">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="bg-brand-card border border-brand-gold/40 rounded-xl p-4 text-center mb-6" data-id="element-53">
          <p className="text-sm sm:text-base font-bold text-brand-cream" data-id="element-54">
            Valore totale dei bonus:{' '}
            <span className="text-brand-gold" data-id="element-55">56€</span> — INCLUSI GRATIS
          </p>
        </div>
      </div>
    </section>;
}